import Vue from 'vue';
import VueRouter from 'vue-router';

import routes from './routes';

Vue.use(VueRouter);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function ({ store } /* { store, ssrContext } */) {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  });

  // Guard global
  Router.beforeEach((to, from, next) => {
    const currentSearch = store.state.questions.lastSearch;
    const hasCurrentSearch = Object.keys(currentSearch).length;

    // const isAuthenticated = store.getters.isAuthenticated;

    if (to.matched.some((record) => record.meta.requiresSearch)) {
      if (!hasCurrentSearch) {
        next({ name: 'ResearchForm' });
      } else {
        next();
      }
    } else {
      next();
    }
  });

  return Router;
}
